import IconFlagSwitzerland from '@/components/icons/markets/IconFlagSwitzerland.vue'
import IconFlagGermany from '@/components/icons/markets/IconFlagGermany.vue'
import { CURRENCIES } from '@/constants/currencies.constants.js'

export const MARKET_SWITZERLAND = 'switzerland'
export const MARKET_GERMANY = 'germany'

export const MARKETS = [
  MARKET_SWITZERLAND,
  MARKET_GERMANY
]

export const MARKET_GOOGLE_IDS = {
  [MARKET_SWITZERLAND]: 'ChIJYW1Zb-9kjEcRFXvLDxG1Vlw',
  [MARKET_GERMANY]: 'ChIJa76xwh5ymkcRW-WRjmtd6HU'
}

export const MARKET_FLAGS = {
  [MARKET_SWITZERLAND]: IconFlagSwitzerland,
  [MARKET_GERMANY]: IconFlagGermany
}

export const MARKET_CURRENCIES = {
  [MARKET_SWITZERLAND]: CURRENCIES.CHF,
  [MARKET_GERMANY]: CURRENCIES.EUR
}

/**
 * Currency for a candidate's market selection:
 * single market → its currency, several markets (or none) → CHF.
 */
export const getMarketsCurrency = (markets) =>
  markets?.length === 1
    ? (MARKET_CURRENCIES[markets[0]] ?? CURRENCIES.CHF)
    : CURRENCIES.CHF
